const winW = $(window).width();

function closeFn(lightbox) {
    var btnClose = lightbox.find('.btnClose');
    btnClose.click(function(e) {
        TweenMax.to(lightbox, .2, { opacity: 0, display: 'none', ease: Circ.easeOut });
        // tab 點選 btnClose
        if (e.detail === 0) {
            $('.arti_pic').focus();
        }
    });
    lightbox.click(function(e) {
        if ($(e.target).is(lightbox))
            TweenMax.to(lightbox, .2, { opacity: 0, display: 'none', ease: Circ.easeOut });
    });

}

function lbFn(_this) {
    closeFn(_this);
    TweenMax.to(_this, .4, {
        opacity: 1,
        display: 'flex',
        ease: Circ.easeOut,
        onComplete: function() {
            if (winW <= 768) return;
            scrollBox();
        }
    });
}

$(document).ready(function() {
    var lightbox = $('.lightbox');
    var lbBtn = $('.lbBtn');
    closeFn(lightbox);
    lbBtn.click(function() {
        var data = $(this).data('lb');
        TweenMax.to($('#' + data), .4, {
            opacity: 1,
            display: 'flex',
            ease: Circ.easeOut,
            onComplete: function() {
                if (winW <= 768) return;
                scrollBox();
            }
        });
    });

    // tab 點選
    $('.lbBtn').keypress(function(e) {
        if (e.which == 13) {
            var data = $(this).data('lb');
            TweenMax.to($('#' + data), .4, {
                opacity: 1,
                display: 'flex',
                ease: Circ.easeOut,
                onComplete: function() {
                    if (winW <= 768) return;
                    scrollBox();
                    lb_acc();
                }
            });
        }
    });

    function lb_acc() {

        var focusedElementBeforeModal;
        focusedElementBeforeModal = document.activeElement;

        var modal = document.querySelector('.lightbox');
        modal.addEventListener('keydown', trapTabKey);

        var focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';
        var focusableElements = modal.querySelectorAll(focusableElementsString);

        focusableElements = Array.prototype.slice.call(focusableElements);

        var firstTabStop = focusableElements[0];
        var lastTabStop = focusableElements[focusableElements.length - 1];
        firstTabStop.focus();

        function trapTabKey(e) {

            if (e.keyCode === 9) {

                // SHIFT + TAB
                if (e.shiftKey) {
                    if (document.activeElement === firstTabStop) {
                        e.preventDefault();
                        lastTabStop.focus();
                    }

                    // TAB
                } else {
                    if (document.activeElement === lastTabStop) {
                        e.preventDefault();
                        firstTabStop.focus();
                    }
                }
            }

            // ESCAPE
            if (e.keyCode === 27) {
                TweenMax.to(lightbox, .2, { opacity: 0, display: 'none', ease: Circ.easeOut });
                focusedElementBeforeModal.focus();
            }
        }
    }

});